import { ConfirmDialog } from "@/pages/tina/festivals/components/confirm-dialog";
import { kindChangeText } from "@/pages/tina/festivals/lib/page-copy";
import type { FestivalPageRead } from "@/types/tina-festival-page";

interface KindChangeDialogProps {
  page: FestivalPageRead;
  /** The kind asked for; null keeps the dialog closed. */
  to: "day_ticket" | "program" | null;
  dirty: boolean;
  onClose: () => void;
  onConfirm: (to: "day_ticket" | "program") => void;
}

/** Changing a festival's type is a write to Tina, not a form edit: it is confirmed in words first. */
export function KindChangeDialog({
  page,
  to,
  dirty,
  onClose,
  onConfirm,
}: KindChangeDialogProps) {
  const target = to ?? (page.kind === "program" ? "day_ticket" : "program");
  const text = kindChangeText(page, target, dirty);
  return (
    <ConfirmDialog
      open={to !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title={text.title}
      description={text.description}
      confirmLabel="Change type"
      cancelLabel="Keep it"
      onConfirm={() => {
        if (to !== null) onConfirm(to);
      }}
    />
  );
}
